var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerPallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;fill:#1E1E1E;enable-background:new    ;}\n\t.st1{fill:#BC8757;}\n\t.st2{opacity:0.5;}\n\t.st3{fill:#CE9A64;}\n\t.st4{opacity:0.5;fill:#CE9A64;enable-background:new    ;}\n\t.st5{enable-background:new    ;}\n\t.st6{opacity:0.2;fill:#BC8757;enable-background:new    ;}\n\t.st7{opacity:0.5;fill:#BC8757;enable-background:new    ;}\n\t.st8{fill:#C89460;}\n\t.st9{fill:#FFCD51;}\n\t.st10{opacity:0.5;fill:#FFCD51;enable-background:new    ;}\n\t.st11{opacity:0.2;}\n\t.st12{fill:#FFDC91;}\n\t.st13{fill:#FFB900;}\n\t.st14{fill:#FF3E6D;}\n\t.st15{opacity:0.5;fill:#CED5E3;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "380.9,255 228.3,166.9 193.5,166.9 41,255 193.5,343 228.3,343  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "41,249.9 59.3,239.4 211.7,327.4 211.7,332.5 193.5,343 41,255  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "193.5,338 193.5,343 41,255 41,249.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "211.7,327.4 211.7,332.5 193.5,343 193.5,338  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "193.5,291.5 175.2,302 175.2,327.4 193.5,338 211.8,327.4 211.8,302  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "175.2,302 175.2,327.4 193.5,338 193.5,312.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "193.5,312.6 193.5,338 211.8,327.4 211.8,302  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "59.3,213.9 41,224.5 41,249.9 59.3,260.5 77.5,249.9 77.5,224.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "59.3,235.1 59.3,260.5 77.5,249.9 77.5,224.5  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "41,224.5 41,249.9 59.3,260.5 59.3,235.1  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "41,219.5 59.3,209 211.7,297.1 211.7,302 193.5,312.6 41,224.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.7,297.1 59.3,209 41,219.5 193.5,307.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "193.5,307.6 193.5,312.6 41,224.5 41,219.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "211.7,297.1 211.7,302 193.5,312.6 193.5,307.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "175.2,172.5 193.5,161.9 346,249.9 346,255 327.8,265.5 175.2,177.5  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "327.8,260.5 327.8,265.5 175.2,177.5 175.2,172.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "346,249.9 346,255 327.8,265.5 327.8,260.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "327.8,213.9 309.4,224.5 309.4,249.9 327.8,260.5 346.1,249.9 346.1,224.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "327.8,235.1 327.8,260.5 346.1,249.9 346.1,224.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "309.4,224.5 309.4,249.9 327.8,260.5 327.8,235.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "193.5,136.4 175.2,147 175.2,172.5 193.5,183 211.8,172.5 211.8,147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "193.5,157.6 193.5,183 211.8,172.5 211.8,147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "175.2,147 175.2,172.5 193.5,183 193.5,157.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "175.2,142 193.5,131.5 346,219.5 346,224.5 327.8,235.1 175.2,147  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "346,219.5 193.5,131.5 175.2,142 327.8,230  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "327.8,230 327.8,235.1 175.2,147 175.2,142  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "346,219.5 346,224.5 327.8,235.1 327.8,230  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "211.7,137 193.5,126.5 41,214.5 41,219.5 59.3,230 211.7,142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.3,225.1 59.3,230 211.7,142 211.7,137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "41,214.5 41,219.5 59.3,230 59.3,225.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "238.9,152.7 220.6,142.1 68.1,230.2 68.1,235.2 86.3,245.7 238.9,157.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "86.3,240.7 86.3,245.7 238.9,157.7 238.9,152.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "68.1,230.2 68.1,235.2 86.3,245.7 86.3,240.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "265.6,168.1 247.4,157.6 94.9,245.7 94.9,250.6 113.2,261.2 265.6,173.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.2,256.2 113.2,261.2 265.6,173.1 265.6,168.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "94.9,245.7 94.9,250.6 113.2,261.2 113.2,256.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "292.4,183.6 274.1,173.1 121.7,261.1 121.7,266.1 139.9,276.7 292.4,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "139.9,271.6 139.9,276.7 292.4,188.6 292.4,183.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "121.7,261.1 121.7,266.1 139.9,276.7 139.9,271.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "319.2,199 300.9,188.5 148.4,276.5 148.4,281.6 166.7,292.1 319.2,204.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "166.7,287.1 166.7,292.1 319.2,204.1 319.2,199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "148.4,276.5 148.4,281.6 166.7,292.1 166.7,287.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "346,214.5 327.8,203.9 175.2,292 175.2,297.1 193.5,307.6 346,219.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "193.5,302.6 193.5,307.6 346,219.5 346,214.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "175.2,292 175.2,297.1 193.5,307.6 193.5,302.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "123.7,176.1 184.2,210.9 244.8,176 244.8,118.2 184.3,83.3 123.7,118.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "184.2,153.2 184.2,210.9 244.8,176 244.8,118.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "189.1,194.6 189.1,202.7 206,192.9 206,184.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "123.7,118.3 123.7,176.1 184.2,210.9 184.2,153.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "147,131.7 147,158 160.9,166 160.9,139.8 221.5,104.7 207.6,96.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "147,131.7 147,158 160.9,166 160.9,139.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "175.5,156.1 115,121 54.4,155.8 54.3,213.5 114.8,248.7 175.3,214  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "54.4,155.8 54.3,213.5 114.8,248.7 115,190.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "93,222.6 93,230.6 109.9,240.4 109.9,232.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "115,190.9 114.8,248.7 175.3,214 175.5,156.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "91.7,134.4 77.8,142.3 138.2,177.5 138.2,203.8 152.1,195.8 152.2,169.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "138.2,177.5 138.2,203.8 152.1,195.8 152.2,169.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "188.7,216.8 249.1,251.6 309.8,216.7 309.8,158.9 249.3,124 188.7,158.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "249.1,193.9 249.1,251.6 309.8,216.7 309.8,158.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "254.1,235.3 254.1,243.4 271,233.6 271,225.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "188.7,158.9 188.7,216.8 249.1,251.6 249.1,193.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "212,172.4 212,198.7 225.9,206.7 225.9,180.5 286.4,145.4 272.6,137.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "212,172.4 212,198.7 225.9,206.7 225.9,180.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "129.7,251 190.1,285.9 250.7,250.9 250.7,193.1 190.3,158.2 129.7,193.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "190.1,228.1 190.1,285.9 250.7,250.9 250.7,193.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "195,269.6 195,277.6 211.9,267.9 211.9,259.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "129.7,193.2 129.7,251 190.1,285.9 190.1,228.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "153,206.7 153,233 166.9,241 166.9,214.7 227.4,179.7 213.5,171.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "153,206.7 153,233 166.9,241 166.9,214.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "129.9,156.8 190.3,191.7 250.9,156.7 250.9,98.9 190.5,64 129.9,99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "190.3,133.9 190.3,191.7 250.9,156.7 250.9,98.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "195.2,175.4 195.2,183.4 212.1,173.7 212.1,165.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "129.9,99 129.9,156.8 190.3,191.7 190.3,133.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "153.2,112.5 153.2,138.7 167.1,146.8 167.1,120.5 227.6,85.4 213.7,77.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "153.2,112.5 153.2,138.7 167.1,146.8 167.1,120.5  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerPallet);
export default __webpack_public_path__ + "static/media/container-pallet.f2c1766009bd68eea11e0f43e7ef3844.svg";
export { ForwardRef as ReactComponent };